"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CJFormSectionContext = exports.CJFormSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var R = __importStar(require("../../utils/ramda"));
var Row_1 = require("../../components/Row");
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("react"));
var CJFormLayout_1 = require("./CJFormLayout");
var MDIcon_1 = require("../../components/MDIcon");
var CJFormContext_1 = require("./CJFormContext");
var Popover_1 = require("../../components/Popover");
var Button_1 = require("../../components/Button");
var CJFormSection = function (_a) {
  var className = _a.className,
    children = _a.children,
    _b = _a.startExpanded,
    startExpanded = _b === void 0 ? false : _b,
    label = _a.label,
    disableFormPageBlockAdjust = _a.disableFormPageBlockAdjust,
    restProps = __rest(_a, ["className", "children", "startExpanded", "label", "disableFormPageBlockAdjust"]);
  var _c = __read((0, react_1.useState)(startExpanded), 2),
    expanded = _c[0],
    setExpanded = _c[1];
  var toggleExpand = function () {
    return setExpanded(R.not);
  };
  var _d = __read((0, react_1.useState)([]), 2),
    names = _d[0],
    setNames = _d[1];
  var addName = function (name) {
    if (!name) return;
    var newData = function (data) {
      return R.uniq(R.append(name, data));
    };
    setNames(newData);
  };
  var removeName = function (name) {
    if (!name) return;
    var newData = R.reject(function (n) {
      return n === name;
    });
    setNames(newData);
  };
  var _e = (0, react_1.useContext)(CJFormContext_1.CJFormContext),
    formState = _e.formState,
    sectionErrorText = _e.sectionErrorText;
  var hasError = R.any(function (n) {
    return !R.isNothing(formState.errors[n]);
  }, names);
  var errorLabel = (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
    wrapperProps: {
      style: {
        marginLeft: "8px"
      }
    },
    tooltip: true,
    content: sectionErrorText
  }, {
    children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      size: 14,
      icon: "alert-circle",
      className: "vsx-cjform-tab-error-label",
      color: "var(--color-icon-critical)"
    })
  }));
  return (0, jsx_runtime_1.jsxs)(CJFormLayout_1.CJFormFullWidthContainer, __assign({
    "data-expanded": expanded,
    className: (0, classnames_1.default)("vsx-cjform-section", className, disableFormPageBlockAdjust && "disable-form-page-block-adjust")
  }, restProps, {
    children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      spacing: "small",
      paddingBottom: expanded ? "none" : undefined,
      align: "center"
    }, {
      children: [(0, jsx_runtime_1.jsx)(Button_1.IconButton, {
        round: true,
        cursor: "pointer",
        onClick: toggleExpand,
        icon: expanded ? "chevron-down" : "chevron-right"
      }), (0, jsx_runtime_1.jsx)("span", __assign({
        className: "vsx-cjform-section-title",
        onClick: toggleExpand
      }, {
        children: label
      })), hasError ? errorLabel : null]
    })), (0, jsx_runtime_1.jsx)(CJFormLayout_1.CJFormLayoutGrid, __assign({
      className: "vsx-cjform-section-children"
    }, {
      children: (0, jsx_runtime_1.jsx)(exports.CJFormSectionContext.Provider, __assign({
        value: {
          names: names,
          addName: addName,
          removeName: removeName
        }
      }, {
        children: children
      }))
    }))]
  }));
};
exports.CJFormSection = CJFormSection;
exports.CJFormSectionContext = react_2.default.createContext({
  names: [],
  addName: R.N,
  removeName: R.N
});